import { InformationCircleIcon } from '@heroicons/react/24/outline';

import { Button } from '@/components/atoms/Button';
import { HeroIcon } from '@/components/atoms/Icon';

interface Props {
  onClick?: () => void;
}

export function PlayerExpandPlayerButton({ onClick = () => {} }: Props) {
  return (
    <div>
      <Button variant="ghost" onClick={onClick}>
        <HeroIcon icon={InformationCircleIcon} />
      </Button>
    </div>
  );
}
